module.exports = __webpack_public_path__ + "img/flexsale-refined-6.3ed53159.png";